// @ts-nocheck
import { Box, Divider, Grid, Typography } from '@mui/material';
import moment from 'moment';

import { formatEntityId } from '../../../../helpers';
import {
  FORTA_GRAY4,
  FORTA_GRAY3,
  FORTA_GRAY2,
  FORTA_WHITE,
  FORTA_SUCCESS,
  FORTA_ERROR,
} from '../../../../utils/colors';
import { getSessionStatus } from '../../../../utils/common';
import { Verdict } from '../constants';
import ClientIcon from '../../../../assets/images/client-card.svg';
import BtIcon from '../../../../assets/images/bt-light.svg';
import ErrorIcon from '../../../../assets/images/error-alert.svg';

import type { Roles } from '../../../../constants';
import type { IBTSession } from '../../../../utils/types';

interface ISessionNotesQACardProps {
  session: IBTSession;
  role: Roles;
}

function ReviewInfoCard(props: ISessionNotesQACardProps) {
  const {
    id,
    date_start,
    client,
    session_provider,
    clinical_qa_review,
  } = props.session;

  const { date_reviewed, score, verdict } = clinical_qa_review ?? {};
  const status = getSessionStatus(props.session);

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        backgroundColor: FORTA_WHITE,
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: 2,
        padding: 2,
      }}
    >
      <Grid container spacing={2} justifyContent="space-between">
        <Grid
          item
          sx={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Grid container spacing={2} justifyContent="space-between">
            <Grid
              item
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <Box>
                <img src={status?.icon} alt="icon" width="40" height="40" />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Typography color={FORTA_GRAY3} align="left">
                    {moment(date_start).format('MM/DD/YYYY')}
                  </Typography>
                  -
                  <Typography color={FORTA_GRAY4} sx={{ fontWeight: 700 }}>
                    {formatEntityId(String(id), 'F')}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <img src={ClientIcon} alt="Client icon" />
                  <Typography color={FORTA_GRAY4} align="left">
                    {client?.first_name} {client?.last_name}
                  </Typography>
                </Box>
              </Box>
              <Grid
                item
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    gap: 1,
                    marginTop: 4,
                  }}
                >
                  <img src={BtIcon} alt="BT icon" />
                  <Typography color={FORTA_GRAY4} align="left">
                    {session_provider?.first_name} {session_provider?.last_name}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Box
              sx={{
                padding: '16px 0px 0px 8px',
              }}
            >
              <Divider
                sx={{
                  color: FORTA_GRAY2,
                  borderWidth: '2px',
                  borderRadius: 2,
                }}
                orientation="vertical"
              />
            </Box>

            <Grid
              item
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                minHeight: '54px',
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '8px',
                  minWidth: '100px',
                }}
              >
                <Typography color={FORTA_GRAY3} align="left">
                  Date and time of review
                </Typography>

                <Typography color={FORTA_GRAY4} align="left">
                  {date_reviewed ? moment(date_reviewed).format('MM/DD/YYYY - hh:mm A') : 'None'}
                </Typography>
              </Box>
            </Grid>
            <Box
              sx={{
                padding: '16px 0px 0px 16px',
              }}
            >
              <Divider
                sx={{
                  color: FORTA_GRAY2,
                  borderWidth: '2px',
                  borderRadius: 2,
                }}
                orientation="vertical"
              />
            </Box>
            <Grid
              item
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                minHeight: '54px',
                gap: 2,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  minWidth: '80px',
                }}
              >
                <Typography color={FORTA_GRAY3} align="left">
                  {verdict}
                </Typography>

                <Typography color={score >= 80 ? FORTA_SUCCESS : FORTA_ERROR} variant="h4">
                  {score}/100
                </Typography>
              </Box>
            </Grid>
            {verdict === Verdict.Fail && (
              <Grid
                item
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 1,
                  flex: 1,
                }}
              >
                <img
                  width={18}
                  height={18}
                  src={ErrorIcon}
                  style={{
                    alignSelf: 'flex-start',
                    marginTop: '4px',
                  }}
                  alt="error icon"
                />
                <Typography
                  sx={{
                    fontSize: '14px',
                    color: FORTA_ERROR,
                    fontWeight: 700,
                    textAlign: 'left',
                    lineHeight: '21px',
                  }}
                >
                  I understand that in compliance with QA guidelines, receiving three (3)
                  &apos;fail&apos; ratings in a quarter will result in a discussion to develop a
                  tailored strategy for future success with Forta. Continued failure will result in
                  a discussion on fit for the Forta program.
                </Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ReviewInfoCard;
